// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3XtnC","inner":"Footer_inner__1fbr4","nextIcon":"Footer_nextIcon__2BBGY","innerLeft":"Footer_innerLeft__aKJQJ"};